import React from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";

// pages
import ConfigEmails from "./list";

const EmailsAssignment = (props) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={ConfigEmails} exact />
      <Route path="*">
        <Redirect to={`${props.match.path}`} />
      </Route>
    </Switch>
  );
};

export default withRouter(EmailsAssignment);
